import type { ColumnTypeFn } from "../types";

export const dateType: ColumnTypeFn = (value) => {
  try {
    return <>{new Date(value).toLocaleDateString()}</>;
  } catch {
    return <>{String(value)}</>;
  }
};
